"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_2 = require("../../../types");
const NativeSection = ({ service }) => {
    if (service === types_2.ServiceType.ADMIN && process.env.BUSINESS_TYPE === types_1.BusinessType.B2B) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { sx: { mb: 2 }, children: (0, jsx_runtime_1.jsx)(ui_kit_1.List, { component: "nav", subheader: (0, jsx_runtime_1.jsx)(ui_kit_1.List.Subheader, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.dashboard.hierarchy.native" }) }), children: (0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemButton, { component: react_router_dom_1.Link, to: "/native/contracts", children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemIcon, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Storage, {}) }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.native.contracts.title" }) })] }) }) }));
};
exports.NativeSection = NativeSection;
//# sourceMappingURL=native.js.map